// eslint-disable-next-line camelcase
export default function O_o(promise) {
  return promise
    .then(data => {
      if (data instanceof Error) return [data];
      return [null, data];
    })
    .catch(err => [err]);
}
